<template lang="pug">
  b-modal#general-modal(:title="modalTitle")
    .callout(:class="modalClass")
      h5 {{ modalContent.title }}
      p {{ modalContent.message }}
      a.btn.btn-primary(:href="modalContent.link.url") {{ modalContent.link.text }}
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('modal', ['default', 'modalTitle', 'modalContent', 'modalClass']),
  },
  methods: {
    ...mapMutations('modal', ['hideModal']),
  },
}
</script>